import React from 'react'

function NoMatch() {
  return (
    <div>Page Not Found!</div>
  )
}

export default NoMatch